export default __webpack_public_path__ + "static/ctaModule_table_mobile-78a4f88f75b12824c756b520d2effaed.webp";